import { LoginForm } from '../components/auth';
import { PublicHeader } from '../components/layout/PublicHeader';

function LoginPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <PublicHeader />
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <LoginForm redirectTo="/dashboard" />
      </div>
    </div>
  );
}

export default LoginPage;
